// extracted by mini-css-extract-plugin
export default {"container":"customers_table_container__dIj9t"};